import { z } from 'zod'

/**
 * Validation schema factory for creating a new project
 * @param t - Translation function from useTranslations
 * @returns Zod schema with translated error messages
 */
export const createProjectSchema = (t: (key: string) => string) =>
  z.object({
    name: z
      .string()
      .min(1, t('validation.nameRequired'))
      .min(3, t('validation.nameMinLength'))
      .max(32, t('validation.nameMaxLength'))
      .regex(/^[a-zA-Z0-9\s\-_]+$/, t('validation.nameInvalidCharacters')),
    description: z.string().max(500, t('validation.descriptionMaxLength')),
  })

/**
 * Type inferred from the create project schema
 */
export type CreateProjectFormData = z.infer<ReturnType<typeof createProjectSchema>>
